module.exports = __webpack_public_path__ + "static/media/SportTourist.10af7213.svg";